<template>
  <b-container fluid>
    <b-jumbotron v-show="!items.length">
      <p>
        <i>{{ $t('Cart.emptyCart') }}</i>
      </p>
      <b-button variant="danger" to="/menu">{{ $t('Cart.menuLink') }}</b-button>
    </b-jumbotron>

    <b-card
      border-variant="danger"
      :header="$t('Cart.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
      v-show="items.length"
    >
      <b-row>
        <b-table
          responsive
          hover
          :items="items"
          :fields="fields"
          striped
          outlined
          thead-class="hidden_header"
        >
          <template v-slot:cell(namevariant)="data">
            <h5>{{data.item.name}} {{data.item.variant}}</h5>
            <p v-if="data.item.style">{{data.item.style}}</p>
            <p v-if="data.item.style && data.item.extras.length > 0">/</p>
            <p v-if="data.item.extras.length > 0">{{data.item.extras.join(', ')}}</p>
          </template>

          <template
            v-slot:cell(pricecurrency)="data"
          >{{data.item.price.toFixed(2)}} {{data.item.currency}}</template>

          <template v-slot:cell(quantity)="data">
            <div class="text-right">
              {{data.item.quantity}}
              <b-button size="sm" left @click="removeFromCart(data.item)" variant="danger">
                <font-awesome-icon icon="minus" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-row>
      <b-row align-v="end" class="float-right" v-show="items.length">
        <b-col>
          <b>{{ $t('Cart.total') }}:&nbsp;{{ total.toFixed(2) }}&nbsp;{{ currency }}</b>
        </b-col>
        <b-col>
          <b-button variant="danger" @click="checkout" class="float-right">{{ $t('Cart.order') }}</b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      config: require('../config/config'),
      clientCountOptions: [],
      selectedCourses: [],
      fields: [
        {
          key: 'namevariant',
          label: this.$i18n.t('Cart.name')
        },
        {
          key: 'pricecurrency',
          label: this.$i18n.t('Cart.price')
        },
        {
          key: 'quantity',
          label: this.$i18n.t('Cart.quantity')
        }
      ]
    }
  },
  mounted () {
    // redirect to home if no stripeConnectUserId
    if (!this.stripeConnectUserId) {
      this.$router.push({ name: 'Home' })
    }
  },
  methods: {
    checkout () {
      // set cartTotal state
      this.$store.dispatch('setCartAmount', {
        total: this.total,
        currency: this.currency
      })

      // navigate to payment form
      this.$router.push({ name: 'Payment' })
    },
    ...mapActions(['removeFromCart'])
  },
  computed: {
    ...mapGetters({
      items: 'cartItems',
      stripeConnectUserId: 'stripeConnectUserId'
    }),
    total () {
      let num = this.items.reduce((total, i) => {
        return total + i.price * i.quantity
      }, 0)
      return Number(Math.round(num + 'e2') + 'e-2')
    },
    currency () {
      if (this.items[0]) {
        return this.items[0].currency
      }
    }
  }
}
</script>

<style scoped>
p {
  display: inline;
}
li {
  list-style-type: none;
  float: left;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.25rem;
  line-height: 0.5;
}
</style>
<style>
.hidden_header {
  display: none;
}
.control-label {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue